import React from 'react';
import { TagV2 } from '@zola/zola-ui/src/components/Tag/TagV2';
import styled from '@emotion/styled';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';

const StyledTagV2 = styled(TagV2)`
  background-color: #ebf1f9;
  color: #276588;
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
`;

export const LetterpressExclusiveTag = (): JSX.Element => {
  return <StyledTagV2>Letterpress exclusive</StyledTagV2>;
};
